import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_HAS_QR_CODE_LINK_ANALYTIC_TAGS_STEP_VISITED =
  'UPDATE_HAS_QR_CODE_LINK_ANALYTIC_TAGS_STEP_VISITED' as const;

export const updateHasQrCodeLinkAnalyticTagsStepVisited = (visited: boolean) => ({
  data: { visited },
  type: UPDATE_HAS_QR_CODE_LINK_ANALYTIC_TAGS_STEP_VISITED,
});

export type UpdateHasQrCodeLinkAnalyticTagsStepVisitedResponseAction = DataAction<
  typeof UPDATE_HAS_QR_CODE_LINK_ANALYTIC_TAGS_STEP_VISITED,
  { visited: boolean }
>;
